export const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  phone: function () {
    return isMobile.Android() || isMobile.iOS();
  },
};



// WEBPACK FOOTER //
// ./src/utilities/mobile.js